import React from "react";
import { connect } from 'react-redux';
import classnames from 'classnames';
import { retrieveData } from '../actions/fetch-data';
import { part_selected, partMoved, savePartsOrder } from '../actions/parts';
import { PARTS, CHAPTERS } from '../constants/endpoints';
import {
  FETCH_PARTS_DATA,
  FETCH_PART_CHAPTER_DATA,
  EDIT_PART_POPUP,
  DELETE_PART_POPUP,
  EDIT_CHAPTER_POPUP,
  DELETE_CHAPTER_POPUP
} from '../constants/constants';
import TagGrid from '../components/tags/tag-grid';
import DraggableExpandingTagItem from '../components/tags/draggable-expanding-tag';
import AddSections from '../components/add/add-sections';
import Header from '../components/headers/header';
import SearchBox from '../components/search/search';

class CategoriesPage extends React.Component {
  constructor(props) {
    super(props)
    this.moveItem = this.moveItem.bind(this)
    this.dragStop = this.dragStop.bind(this)
  }

  componentDidMount(){
    this.props.retrieveData(PARTS, FETCH_PARTS_DATA);
  }

  fetchChildrenChapters(id, url, actionType){
    this.props.part_selected(id);
    this.props.retrieveData(url, actionType, id);
  }
  moveItem(dragIndex, hoverIndex) {
    this.props.partMoved({ dragIndex, hoverIndex });
  }

  dragStop() {
    this.props.savePartsOrder();
  }

  render(){
    const { requestActive } = this.props.state.asyncAction;
    const { parts } = this.props.state.parts;

    let tags = parts.map(( part, index ) => {
      return (
        <DraggableExpandingTagItem
          key={index}
          data={part}
          childTitle='Chapters'
          editAction={EDIT_PART_POPUP}
          deleteAction={DELETE_PART_POPUP}
          editChildAction={EDIT_CHAPTER_POPUP}
          deleteChildAction={DELETE_CHAPTER_POPUP}
          moveItem={this.moveItem}
          dragStop={this.dragStop}
          onSelect={
            this.fetchChildrenChapters.bind(
              this,
              part._id.$oid,
              `${PARTS}/${part._id.$oid}/chapters`,
              FETCH_PART_CHAPTER_DATA
            )
          }
          childUrl={'/categories/chapters'}
        ></DraggableExpandingTagItem>)
    });

    return (
      <div>
        <Header title="Categories" subtitle="View Add Edit & Delete"/>
        <div className="content">
          <SearchBox />
          <div className="mobile-hide">
            <AddSections />
          </div>
          <h2>Categories</h2>
          <TagGrid>
            {tags}
          </TagGrid>
        </div>
      </div>
    );
  }
}

export default connect(
  nextState => ({ state: nextState }),
  { retrieveData, part_selected, partMoved, savePartsOrder }
)(CategoriesPage)
